import {
    FRAGMENT_LISTING_DISCOUNT,
    FRAGMENT_STOREFRONT_DISCOUNT,
} from '@marketplace/graphql/config/shared-fragments.js'
import gql from 'graphql-tag'

export const LISTING_IMAGES = gql`
    query listingImages($id: ID!) {
        listing(id: $id) {
            images(first: 25) {
                edges {
                    node {
                        id
                        x1: transformedUrl(width: 480, height: 480)
                        x2: transformedUrl(width: 800, height: 800)
                        transformedUrl(width: 1200, height: 1200, method: FILL)
                    }
                }
            }
        }
    }
`

export const QUICKBUY_LISTING_QUERY = gql`
    ${FRAGMENT_LISTING_DISCOUNT}
    ${FRAGMENT_STOREFRONT_DISCOUNT}
    query quickBuyListingQuery($listingId: ID!) {
        listing(id: $listingId) {
            ...FragmentGlobalDiscount
            databaseId
            id
            title
            inStock
            caseQuantity
            minimumOrderQuantity
            isReorderOnly
            isFavorite
            url
            images(first: 1) {
                edges {
                    node {
                        id
                        x1: transformedUrl(width: 260, height: 260)
                    }
                }
            }
            variants {
                id
                databaseId
                title
                price
                discountPercentage
                msrp
                inventory
                options {
                    name
                    value
                }
                inventoryPolicy
                inStock
            }
            storefront {
                ...FragmentStorefrontGlobalDiscount
                id
                name
                slug
                databaseId
                shippingCountries
                status

            }
        }
    }
`
